module.exports = __webpack_public_path__ + "img/racecourse-fairview-poly-1300.f36e5f10.svg";